/* cali 2026-09-29 gallery-rail: edge fade on the product thumbnail rail.
 *
 * Replaces Motion's rail arrow (the white pill) as the "there are more photos" cue on
 * phones. This file only reads the rail's scroll position and toggles two classes on
 * `.product__thumbs`; the fade itself is CSS (block "gallery-rail" at the end of
 * assets/theme.css.liquid), so nothing here changes layout. The arrows are still
 * rendered (the templates keep `thumbnail_arrows: true`) and that same block hides them.
 *
 *   cali-rail--more-end    there are thumbnails after the visible ones
 *   cali-rail--more-start  the rail has been scrolled away from its start
 *
 * Neither is set when everything fits (FIT px of overflow or less). The position is
 * re-read on scroll (passive, once per animation frame), when the scroller or a
 * thumbnail changes size, and when a thumbnail's class changes: choosing a colour hides
 * the thumbnails of the other colours (`.hide` on `.product__thumb-item`, theme.js
 * updateImageSetThumbs), which changes how much there is to scroll.
 *
 * Loaded with `defer` from snippets/product-images.liquid, which can render more than
 * once per page, hence the guard. Scroll-driven CSS animations would do this without
 * script, but Safari only has them from 26.0.
 */
(function () {
  'use strict';

  if (window.caliThumbRail) return;

  var FIT = 12; // px of overflow still treated as "everything fits"
  var EDGE = 1; // px from an end still treated as "at that end"
  var MORE_START = 'cali-rail--more-start';
  var MORE_END = 'cali-rail--more-end';

  function bind(rail) {
    if (rail.hasAttribute('data-cali-rail')) return;
    var scroller = rail.querySelector('.product__thumbs--scroller');
    if (!scroller) return;
    rail.setAttribute('data-cali-rail', '');

    var vertical = rail.getAttribute('data-position') === 'beside';
    var queued = false;

    function update() {
      queued = false;
      var visible = vertical ? scroller.clientHeight : scroller.clientWidth;
      var total = vertical ? scroller.scrollHeight : scroller.scrollWidth;
      // abs(): scrollLeft is negative in a right-to-left layout.
      var pos = Math.abs(vertical ? scroller.scrollTop : scroller.scrollLeft);
      var overflow = total - visible;
      var scrolls = visible > 0 && overflow > FIT;
      rail.classList.toggle(MORE_START, scrolls && pos > EDGE);
      rail.classList.toggle(MORE_END, scrolls && pos < overflow - EDGE);
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    scroller.addEventListener('scroll', queue, { passive: true });

    if ('ResizeObserver' in window) {
      var sizes = new ResizeObserver(queue);
      sizes.observe(scroller);
      rail.querySelectorAll('.product__thumb-item').forEach(function (item) {
        sizes.observe(item);
      });
    } else {
      window.addEventListener('resize', queue, { passive: true });
    }

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].target.classList.contains('product__thumb-item')) {
          queue();
          return;
        }
      }
    }).observe(scroller, { attributes: true, attributeFilter: ['class'], subtree: true });

    update();
  }

  function bindAll(root) {
    (root || document).querySelectorAll('[data-product-thumbs]').forEach(bind);
  }

  window.caliThumbRail = { bind: bindAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindAll(); });
  } else {
    bindAll();
  }

  // Theme editor: a re-rendered section brings a new rail.
  document.addEventListener('shopify:section:load', function (evt) {
    bindAll(evt.target);
  });
})();
